const l = {
  name: "CrossCircleFillSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10.0002 8.58582L8.58594 10L10.5859 12L8.58594 14L10.0002 15.4142L12.0002 13.4142L14.0002 15.4142L15.4144 14L13.4144 12L15.4144 10L14.0002 8.58582L12.0002 10.5858L10.0002 8.58582Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as CrossCircleFillSmall
};
